import { updateObject } from "../Utility";
import {
  JOB_POSITION_CATEGORIES_GET_START,
  JOB_POSITION_CATEGORIES_GET_SUCCESS,
  JOB_POSITION_CATEGORIES_GET_FAIL,
} from "../actions/JobPositionCategoriesActions";

const initialState = {
  items: {},
  itemsArray: [],
  loading: false,
  fetched: false,
  error: null,
};

// GET:
const getJobPositionCategoriesStart = (state, actions) => {
  return updateObject(state, {
    ...state,
    loading: true,
    error: null,
  });
};

const getJobPositionCategoriesSuccess = (state, action) => {
  return updateObject(state, {
    ...state,
    items: action.jobPositionCategories.reduce((obj, item) => {
      obj[item.id] = item;
      return obj;
    }, {}),
    itemsArray: action.jobPositionCategories,
    loading: false,
    fetched: true,
    error: null,
  });
};

const getJobPositionCategoriesFail = (state, action) => {
  return updateObject(state, {
    ...state,
    loading: false,
    error: action.error,
  });
};

const JobPositionCategoriesReducer = (state = initialState, action) => {
  switch (action.type) {
    // GET:
    case JOB_POSITION_CATEGORIES_GET_START:
      return getJobPositionCategoriesStart(state, action);
    case JOB_POSITION_CATEGORIES_GET_SUCCESS:
      return getJobPositionCategoriesSuccess(state, action);
    case JOB_POSITION_CATEGORIES_GET_FAIL:
      return getJobPositionCategoriesFail(state, action);

    default:
      return state;
  }
};

export default JobPositionCategoriesReducer;
